import React from 'react';
import PropTypes from 'prop-types';
import ContentParser from 'src/ui/library/ContentParser';
import ServiceTitlePres from './ServiceTitlePres';
import ServiceSpinnerPres from './ServiceSpinnerPres';

export default function DynamicContentPres({ dynamicContent, onChange, currentPage }) {
  if (!dynamicContent.pageElements || currentPage === undefined) {
    return <ServiceSpinnerPres />;
  }

  return (
    <React.Fragment>
      <ServiceTitlePres title={currentPage.menuName} />
      <div className="ssi-parser-content">
        <ContentParser
          key={dynamicContent.pageId}
          pageId={dynamicContent.pageId}
          data={dynamicContent}
          onChange={onChange}
          showLabels={false}
          debug={false}
        />
      </div>
    </React.Fragment>
  );
}

DynamicContentPres.propTypes = {
  dynamicContent: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  currentPage: PropTypes.object.isRequired,
};
